<proto-image class="image-upload__inner"
  [ngClass]="imageType"
  [showPlaceholderImage]="!imageId && showPlaceholderImage"
  [imageType]="imageType"
  [imageUrl]="imageUrl"
  (imageClicked)="showActionsheet()"
  (imageLoaded)="onUploadedImageLoaded()">
  <div class="proto-image-content" [ngClass]="{ 'is-active': imageIsLoading }">
    @if (imageIsLoading) {
      <ion-spinner color="light"></ion-spinner>
    }
  </div>
</proto-image>
<ng-content select=".image-upload-content"></ng-content>
